import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Preview from './Preview'
import { State } from '../../dataStore/reducers/reducerType'
import selectHasTwilioRoom from '../../dataStore/selectors/selectHasTwilioRoom'
import selectHasTwilioDocs from '../../dataStore/selectors/selectHasTwilioDocs'
import selectHasWebcastData from '../../dataStore/selectors/selectHasWebcastData'
import { setPresenterTracks, joinRoom } from '../../dataStore/actions/setup/setupActions'
import selectHasPresenterSeat from '../../dataStore/selectors/selectHasPresenterSeat'
import { addSeatToMap } from '../../dataStore/actions/seatingOrder/seatingOrderSyncFunctions'
import { PreviewProps } from './types'

const mapStateToProps = (state: State): Omit<PreviewProps, 'onEnterClick' | 'history' | 'location' | 'match'> => ({
  hasSeat: selectHasPresenterSeat(state),
  hasDocs: selectHasTwilioDocs(state),
  hasRoom: selectHasTwilioRoom(state),
  hasWebcastData: selectHasWebcastData(state),
  roomname: state.config.roomname,
  username: state.config.username
})

const mapDispatchToProps = (dispatch) => ({
  onEnterClick: identity => {

    addSeatToMap(identity)
    dispatch(setPresenterTracks())
    dispatch(joinRoom())

  }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Preview))
